export const TRACKED_PARAMS = ['gclid', 'gbraid', 'wbraid']
const STORAGE_KEY = 'librario.adClickIds'

function readStored() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}
  } catch {
    return {}
  }
}

// URL query ∪ sessionStorage, allowlist-only. Order-independent so the capture
// and fields controllers never race on connect order.
export function readClickIds() {
  const stored = readStored()
  const url = new URLSearchParams(window.location.search)
  const out = {}
  for (const key of TRACKED_PARAMS) {
    const value = url.get(key) || stored[key]
    if (value) out[key] = value
  }
  return out
}

// Merge an explicit allowlisted click-ID object into sessionStorage (last-touch).
// Used by the consent banner to persist its in-memory held IDs once consent is given.
export function storeClickIds(ids) {
  const stored = readStored()
  let changed = false
  for (const key of TRACKED_PARAMS) {
    if (ids[key]) {
      stored[key] = ids[key]
      changed = true
    }
  }
  if (changed) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
}

// Reads all allowlisted click IDs from the current URL (no sessionStorage merge).
export function readUrlClickIds() {
  const url = new URLSearchParams(window.location.search)
  const ids = {}
  for (const key of TRACKED_PARAMS) {
    const value = url.get(key)
    if (value) ids[key] = value
  }
  return ids
}

// Last-touch merge: a present URL param overwrites; absent keys are preserved.
export function captureClickIds() {
  storeClickIds(readUrlClickIds())
}
